module.exports = __webpack_public_path__ + "static/3-91c45c6677052e1d12ff09bd26a48256.png";